import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Category } from 'src/models/Category';
import { ClientUser, FullClientUser, RetailerUserClaims } from 'src/models/ClientUser';
import { DayFlags, Offer, OfferCodeDisplayType, OfferCodeType, OfferLocationType } from 'src/models/Offer';
import { Retailer, RetailerWithLocations } from 'src/models/Retailer';
import { RetailerLocation } from 'src/models/RetailerLocation';
import jwtDecode from "jwt-decode";
import { ApiError, InvalidDataError, NotFoundApiError } from './ApiError';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(public auth: AngularFireAuth) { }

  // async getRetailer() : Promise<Retailer> {
  //   return this.DUMMY_GetRetailer();
  // }

  // async getRetailerLocations( sortColumn?: string, sortDesc?: boolean, pageSize?: number, pageIndex?: number) : Promise<RetailerLocation[]> {
  //   var locs = this.DUMMY_GetRetailerLocations();
  //   if (sortColumn) {
  //     locs.sort((a, b) => (a[sortColumn] > b[sortColumn])?(sortDesc?-1:1):(a[sortColumn] < b[sortColumn]?(sortDesc?1:-1):0));
  //   }
  //   return locs;
  // }



  async authedGet(path: string) {
    const usr = await this.auth.currentUser;
    const token = await usr.getIdToken();
    if (path.startsWith("/")) {
      path = path.substring(1);
    }
    console.log("getting fetch");
    const res = await fetch(`${this.adminurlbase}${path}`, {
      method: 'GET',
      headers: {
          'Authorization': `Bearer ${token}`
      }
      });
      if (res.status == 404) {
        throw new NotFoundApiError();
      } else if (res.status >= 400 && res.status < 500) {
        let resp = "";
        try {
          resp = await res.text();
        } catch {}
        throw new InvalidDataError(resp);
      } else if (res.status >= 500) {
        throw new ApiError();
      }
      const json = await res.json();
      console.log("done, returning: " + JSON.stringify(json));
      return json;
  }
  async authedDelete(path: string) {
    const usr = await this.auth.currentUser;
    const token = await usr.getIdToken();
    if (path.startsWith("/")) {
      path = path.substring(1);
    }
    console.log("doing delete fetch");
    const res = await fetch(`${this.adminurlbase}${path}`, {
      method: 'DELETE',
      headers: {
          'Authorization': `Bearer ${token}`
      }
      });
      if (res.status == 404) {
        throw new NotFoundApiError();
      } else if (res.status >= 400 && res.status < 500) {
        let resp = "";
        try {
          resp = await res.text();
        } catch {}
        throw new InvalidDataError(resp);
      } else if (res.status >= 500) {
        throw new ApiError();
      }
      const json = await res.text();
      return json;
  }
  async authedPost(path: string, body: any) {
    const usr = await this.auth.currentUser;
    const token = await usr.getIdToken();
    if (path.startsWith("/")) {
      path = path.substring(1);
    }
    const res = await fetch(`${this.adminurlbase}${path}`, {
      method: 'POST',
      headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
      }, 
      body: (body && typeof body !== "string")?JSON.stringify(body):body
      });
      if (res.status == 404) {
        throw new NotFoundApiError();
      } else if (res.status >= 400 && res.status < 500) {
        let resp = "";
        try {
          resp = await res.text();
        } catch {}
        throw new InvalidDataError(resp);
      } else if (res.status >= 500) {
        throw new ApiError();
      }

      try {
        const json = await res.json();
        return json;
      } catch (e) {
        console.error("failed parsing response");
        console.error(e);
        throw new ApiError(e);
      }
      
  }

  async authedPatch(path: string, body: any) {
    const usr = await this.auth.currentUser;
    const token = await usr.getIdToken();
    if (path.startsWith("/")) {
      path = path.substring(1);
    }
    console.log(`patching to ${path} with ${JSON.stringify(body)}`);
    const res = await fetch(`${this.adminurlbase}${path}`, {
      method: 'PATCH',
      headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
      }, 
      body: (body && typeof body !== "string")?JSON.stringify(body):body
      });
      if (res.status == 404) {
        throw new NotFoundApiError();
      } else if (res.status >= 400 && res.status < 500) {
        let resp = "";
        try {
          resp = await res.text();
        } catch {}
        throw new InvalidDataError(resp);
      } else if (res.status >= 500) {
        throw new ApiError();
      }
      const json = await res.json();
      return json;
  }
  async patchRetailer(retailer: Retailer) : Promise<Retailer> {
    return await this.authedPatch(`retailers/${retailer.id}`, retailer);
  }
  async getRetailersWithLocations() : Promise<RetailerWithLocations[]> {
    console.log("getting it");
    return await this.authedGet("retailers/");
  }
  async getRetailer(retailerId: string) : Promise<RetailerWithLocations> {
    return await this.authedGet(`retailers/${retailerId}`);
  }
  async getRetailerLocation(retailerId: string, locationId: string) : Promise<RetailerLocation> {
    return await this.authedGet(`retailers/${retailerId}/locations/${locationId}`);
  }
  async patchRetailerLocation(retailerId: string, location: RetailerLocation) : Promise<RetailerLocation> {
    return await this.authedPatch(`retailers/${retailerId}/locations/${location.id}`, location);
  }
  async createRetailerLocation(retailerId: string, location: RetailerLocation) : Promise<RetailerLocation> {
    return await this.authedPost(`retailers/${retailerId}/locations`, location);
  }
  async createRetailer(retailer: Retailer) : Promise<RetailerWithLocations> {
    return await this.authedPost(`retailers/`, retailer);
  }
  async deleteRetailer(retailerId: string) : Promise<void> {
    await this.authedDelete(`retailers/${retailerId}`);
  }
  adminurlbase = "https://us-central1-localiti-1.cloudfunctions.net/api/v1/admin/";
  //adminurlbase = "http://localhost:5001/localiti-1/us-central1/api/v1/admin/";
  async getOffersForRetailer(retailerId: string, sortColumn?: string, sortDesc?: boolean, pageSize?: number, pageIndex?: number) : Promise<Offer[]> {
    console.log("getting offers");
    const ret : Offer[] = await this.authedGet(`retailers/${retailerId}/offers`);
    for (let r of ret) {
      if (!r.availability) {
        r.availability = {}
        if (!r.locationIds) {
          r.locationIds = [];
        }
      }
    }
    return ret;
    
    //return this.DUMMY_GetOffers().filter(x=> x.retailer_location_id == retailer_location_id);
  }

  private cachedClientUser : FullClientUser;
  async getClientUser(uid: string = "me") : Promise<FullClientUser|null> {
    const meuser = (await this.auth.currentUser).uid;
    // if (uid == "me" && this.cachedClientUser && this.cachedClientUser.id == meuser) {
    //   console.log("returning cached");
    //   return this.cachedClientUser;
    // }
    console.log("getting client user for " + uid);
    try {
      const ret = await this.authedGet(`accounts/${uid}`);
      console.log("got client user ", ret);
      if (uid == "me" && ret.id == meuser) {
        this.cachedClientUser = ret;
      }
      return ret;
    } catch (e) {
      if (e instanceof NotFoundApiError) {
        return null;
      }
      throw e;
    }
  }
  async adminGetAllClientUsers() : Promise<FullClientUser[]> {
    return await this.authedGet('/accounts')
  }

  async getClaims(forceRefresh: boolean = false) : Promise<RetailerUserClaims> {
    const currentToken = await (await this.auth.currentUser).getIdToken(forceRefresh);
    const decoded = jwtDecode(currentToken);
    console.log("decoded:");
    console.log(JSON.stringify(decoded, null, 3));

    return {
      global_admin: decoded["global_admin"] === true,
      retailer: decoded["retailer"] === true,
      client: decoded["client"] === true
    };
  }
  async patchClientUser(clientUser: FullClientUser, uid: string="me") : Promise<FullClientUser> {
      const ret = await this.authedPatch(`accounts/${uid}`, clientUser);
      this.cachedClientUser = null;
      return ret;
  }

  async createClientUser(clientUser: ClientUser, uid: string="me") : Promise<FullClientUser> {
    console.log("creating client user for " + uid);
    const ret = await this.authedPost(`accounts/${uid}`, clientUser);
    console.log("created client user ", ret);
    this.cachedClientUser = null;
    return ret;
  }

  async getCategories() : Promise<Category[]> {
    return <Category[]>[
      {id: "golf", name: "Golf"},
      {id: "restaraunt", name: "Restaraunts"},
      {id: "artsentertainment", name: "Arts and Live Entertainment"},
      {id: "winebeer", name: "Wine and Beer Establishments"},
      {id: "family", name: "Family Activities"},
      {id: "hotel", name: "Hotels"},
      {id: "spa", name: "Spa"},
      {id: "breakfast", name: "Breakfast"},
      {id: "pizza", name: "Pizza"},
      {id: "coffee", name: "Coffee House"},
      {id: "grocery", name: "Grocery"},
      {id: "buffet", name: "Buffets"},
      {id: "clothing", name: "Clothing"},
      {id: "fishing", name: "Fishing"},
      {id: "golfgear", name: "Golf Gear"}
    ];
  }

  async deleteRetailerOffer(retailerId: string, offer: Offer) : Promise<void> {
    if (!offer.id) {
      return;
    }
    await this.authedDelete(`retailers/${retailerId}/offers/${offer.id}`);
  }

  async deleteRetailerLocation(retailerId: string, location: RetailerLocation) : Promise<void> {
    if (!location.id) {
      return;
    }
    await this.authedDelete(`retailers/${retailerId}/locations/${location.id}`);
  }

  async createRetailerOffer(retailerId: string, offer: Offer) : Promise<Offer> {
    return this.authedPost(`retailers/${retailerId}/offers`, offer);
  }
  async patchRetailerOffer(retailerId: string, offer: Offer) : Promise<Offer> {
    return this.authedPatch(`retailers/${retailerId}/offers/${offer.id}`, offer);
  }
  async getOfferForRetailer(retailerId: string, offerId: string) : Promise<Offer> {
    const r = await this.authedGet(`/retailers/${retailerId}/offers/${offerId}`);    
    if (r) {
      if (!r.availability) {
        r.availability = {}
        if (!r.locationIds) {
          r.locationIds = [];
        }
      }
    }
    return  r;
  }
  

}
